const advanceCookieElement = document.querySelector('.advance-cookie-banner');

if (advanceCookieElement) {
  document.querySelectorAll('input[data-cookie="advertising_cookie"]').forEach((input) => {
    (input.closest('.advance-cookie-banner__modal-item') || input).remove();
  });

  const cookieInputs = document.querySelectorAll('.advance-cookie-banner__modal input');
  const essentialCookie = document.querySelectorAll('.is-necessary input');
  const cookieModalContainer = document.querySelector('.advance-cookie-banner__modal');
  const cookieModalFocusable = cookieModalContainer?.querySelector('.advance-cookie-banner__modal-close');
  const analyticsToggle = document.querySelector(
    '.advance-cookie-banner__modal input[data-cookie="performance_cookie"]',
  );
  const cookieOptions = {
    expires: 365,
    path: '/',
    sameSite: 'Lax',
    secure: window.location.protocol === 'https:',
  };
  const cookiePaths = ['/'];
  let cookiePath = window.location.pathname;

  while (cookiePath && cookiePath !== '/') {
    if (!cookiePaths.includes(cookiePath)) cookiePaths.push(cookiePath);
    cookiePath = cookiePath.substring(0, cookiePath.lastIndexOf('/')) || '/';
  }
  const isValidCookieDomain = (domain) =>
    /^(?=.{1,253}$)(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}$/i.test(domain);
  const hostname = window.location.hostname.toLowerCase();
  const cookieDomains = [];

  if (isValidCookieDomain(hostname)) {
    cookieDomains.push(hostname, `.${hostname}`);

    const parentDomain = hostname.substring(hostname.indexOf('.') + 1);
    if (isValidCookieDomain(parentDomain)) cookieDomains.push(parentDomain, `.${parentDomain}`);

    // GA writes on the registrable parent; never widen cleanup to public suffixes.
    if (hostname === 'zf.uni-lj.si' || hostname.endsWith('.zf.uni-lj.si')) {
      cookieDomains.push('uni-lj.si', '.uni-lj.si');
    }
  }

  if (Cookies.get('necessary_cookie') !== 'v2') {
    advanceCookieElement.classList.add('cookie-not-set');
  }

  const removePreferenceCookie = (name) => {
    cookiePaths.forEach((path) => {
      Cookies.remove(name, { path });
      cookieDomains.forEach((domain) => Cookies.remove(name, { path, domain }));
    });
  };

  const removeAnalyticsCookies = () => {
    const cookieNames = document.cookie
      .split(';')
      .map((cookie) => cookie.trim().split('=')[0])
      .filter((name) => name === '_ga' || name.startsWith('_ga_'));

    [...new Set(['_ga', '_ga_42M4Y7V46R', ...cookieNames])].forEach(removePreferenceCookie);
  };

  const storeNecessaryChoice = () => {
    Cookies.set('necessary_cookie', 'v2', cookieOptions);
  };

  const closeCookieModal = () => {
    const modalEle = document.querySelector('.advance-cookie-banner__modal.is-open-modal');

    cookieModalContainer?.setAttribute('inert', '');
    cookieModalContainer?.setAttribute('aria-hidden', 'true');

    if (modalEle) {
      modalEle.classList.remove('is-open-modal');
      toggleBodyScrollLock(false);
    }
  };

  const toggleCookieInput = (elem, toggle) => {
    elem.checked = toggle;
  };

  const acceptAnalytics = () => {
    storeNecessaryChoice();
    Cookies.set('performance_cookie', 'true', cookieOptions);
    removePreferenceCookie('advertising_cookie');
    if (analyticsToggle) analyticsToggle.checked = true;
    window.ZFConsent?.enableAnalytics();
    advanceCookieElement.classList.remove('cookie-not-set');
    closeCookieModal();
  };

  const rejectAll = () => {
    storeNecessaryChoice();
    removePreferenceCookie('performance_cookie');
    removePreferenceCookie('advertising_cookie');
    if (analyticsToggle) analyticsToggle.checked = false;
    window.ZFConsent?.disableAnalytics();
    removeAnalyticsCookies();
    closeCookieModal();
    advanceCookieElement.classList.remove('cookie-not-set');
    window.location.reload();
  };

  const saveChoice = () => {
    if (analyticsToggle?.checked === true) {
      acceptAnalytics();
    } else {
      rejectAll();
    }
  };

  attachEvent('.btn--accept-cookie, .btn--accept-all', 'click', (event) => {
    event.preventDefault();
    acceptAnalytics();
  });

  attachEvent('.btn--confirm-choice', 'click', (event) => {
    event.preventDefault();
    saveChoice();
  });

  attachEvent('.btn--decline-cookie, .btn--decline-choice', 'click', (event) => {
    event.preventDefault();
    rejectAll();
  });

  // *******************************************************************************
  // Check already set cookie on load
  // *******************************************************************************
  cookieInputs.forEach((item) => {
    const cookieName = item.getAttribute('data-cookie');
    toggleCookieInput(item, Cookies.get(cookieName) === 'true');
  });

  essentialCookie.forEach((input) => {
    toggleCookieInput(input, true);
  });

  // *******************************************************************************
  // Open Modal
  // *******************************************************************************
  attachEvent('.btn--cookie-setting, .open-cookie-settings', 'click', (ev) => {
    document.querySelector('.advance-cookie-banner__modal').classList.add('is-open-modal');

    cookieModalContainer?.removeAttribute('inert');
    cookieModalContainer?.removeAttribute('aria-hidden');
    cookieModalFocusable?.focus();

    toggleBodyScrollLock(true);
    ev.preventDefault();
  });

  // *******************************************************************************
  // Close Modal
  // *******************************************************************************
  attachEvent(
    '.advance-cookie-modal__close-btn, .advance-cookie-banner__modal-overlay, .advance-cookie-banner__modal-close',
    'click',
    (ev) => {
      ev.target.closest('.advance-cookie-banner__modal').classList.remove('is-open-modal');

      cookieModalContainer?.setAttribute('inert', '');
      cookieModalContainer?.setAttribute('aria-hidden', 'true');

      toggleBodyScrollLock(false);
      ev.preventDefault();
    },
  );

  // Close bar on click of 'X'
  attachEvent('.advance-cookie-banner__close', 'click', (ev) => {
    ev.target.closest('.advance-cookie-banner').classList.remove('cookie-not-set');
    ev.preventDefault();
  });

  // ESC close
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeCookieModal();
    }
  });

  cookieModalContainer?.addEventListener('focusout', () => {
    setTimeout(() => {
      const activeEl = document.activeElement;

      if (cookieModalContainer && activeEl && !cookieModalContainer.contains(activeEl)) {
        closeCookieModal();
      }
    }, 10);
  });
}
